import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useGame } from '../context/GameContext';
import { NoirBackground, Button, GameCard } from '../components/GameUI';
import { toast } from 'sonner';
import { checkWinCondition } from '../utils/gameLogic';

const MrWhiteGuess = () => {
  const { wordPair, setWinner, setGameState, players, round, setRound } = useGame();
  const [guess, setGuess] = useState('');

  const submit = () => {
    if (!guess.trim()) { toast.error('Enter a guess'); return; }
    if (guess.trim().toLowerCase() === wordPair.civilian.toLowerCase()) {
      setWinner({ winner: 'mrwhite', message: 'Mr. White cracked the case!' }); setGameState('results');
    } else {
      toast.error('Wrong guess — case closed for Mr. White.');
      const w = checkWinCondition(players);
      if (w) { setWinner(w); setGameState('results'); } else { setRound(round + 1); setGameState('gameRound'); }
    }
  };

  return (
    <div className="min-h-dvh flex flex-col items-center justify-center p-6 relative select-none">
      <NoirBackground />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md space-y-6 relative z-10">
        <div>
          <div className="font-mono text-[#5A5A5A] text-xs uppercase tracking-[0.3em] mb-2">Last Chance</div>
          <h1 className="font-typewriter text-5xl text-[#E0DDD5] leading-tight">Mr. White's Deduction</h1>
          <div className="red-line w-full mt-3" />
        </div>
        <GameCard className="space-y-4">
          <div className="text-[#E0DDD5] font-bold text-center text-sm uppercase tracking-wider">What is the Civilian word?</div>
          <input data-testid="mrwhite-guess-input" type="text" value={guess}
            onChange={(e) => setGuess(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && submit()}
            placeholder="Type your deduction..."
            className="w-full bg-gradient-to-b from-[#111] to-[#0A0A0A] border border-[#333] rounded p-4 text-xl text-center text-[#E0DDD5] font-typewriter placeholder:text-[#333] focus:outline-none focus:border-[#E0DDD5]"
            autoFocus autoComplete="off" />
        </GameCard>
        <div className="font-mono text-[#333] text-xs text-center uppercase tracking-wider">
          Correct = Case won &middot; Wrong = Investigation continues
        </div>
        <Button data-testid="submit-guess-btn" color="white" onClick={submit}>Submit Deduction</Button>
      </motion.div>
    </div>
  );
};

export default MrWhiteGuess;
